import React, { useEffect } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import CommonButtons from "../../../../../shared/components/CommonButtons";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { useUser } from "src/shared/context/UserContext";
import { normalizeFoodTypes } from "src/shared/utils/normalizeFoodTypes";

interface SearchAndFilterProps {
  selectedCategoryradio: string;
  setSelectedCategoryradio: (value: string) => void;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  handleOpenDialog: () => void;
  newopen: boolean;
  handleCloseDialog: () => void;
  handleReload: () => void;
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
  selectedCategoryradio,
  setSelectedCategoryradio,
  searchQuery,
  setSearchQuery,
  handleOpenDialog,
  newopen,
  handleCloseDialog,
  handleReload,
}) => {
  const { fontClass, borderHighlight } = useUserTheme();
  const { userConfigration } = useUser();

  // Normalize food types from user configuration
  const foodTypes = userConfigration?.foodTypes 
    ? normalizeFoodTypes(userConfigration.foodTypes)
    : ["Veg", "Non-Veg"];

  // Set default value to "none" when component mounts
  useEffect(() => {
    if (!selectedCategoryradio) {
      setSelectedCategoryradio("none");
    }
  }, [selectedCategoryradio, setSelectedCategoryradio]);

  return (
    <>
      <div className='flex flex-col sm:flex-row justify-between items-center pl-3 p-1 pb-3 gap-2'>
        <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
           <FormControl className="w-full sm:w-auto">
            <FormLabel id='food-type-radio-group'></FormLabel>

            <RadioGroup
              row
              aria-labelledby='food-type-radio-group'
              name='food-type'
              value={selectedCategoryradio || "none"}
              onChange={(e) => setSelectedCategoryradio(e.target.value)}
            >
              {/* ✅ Dynamic food types - now properly normalized */}
              {foodTypes.map((type: string) => (
                <FormControlLabel key={type} value={type} control={<Radio />} label={type} />
              ))}

              {/* ✅ All option */}
              <FormControlLabel value='none' control={<Radio />} label='All' />
            </RadioGroup>
          </FormControl>
        </div>

        <input
          id='search-food-items'
          placeholder='Search food items'
          className={`w-full sm:w-64 px-3 py-2.5 border rounded-3xl focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {newopen && (
        <ModalWrapper title='Confirm New Order' onClose={handleCloseDialog} width='max-w-lg'>
          <p className='text-gray-700 mb-6 w-[400px]'>
            You have unsaved changes. Are you sure you want to start a new order? All changes will be lost.
          </p>
          <div className='flex justify-end gap-6'>
            <CommonButtons className='w-32' label='Cancel' variant='outlineDanger' onClick={handleCloseDialog} />
            <CommonButtons className='w-32' label='Confirm' variant='primary' onClick={handleReload} />
          </div>
        </ModalWrapper>
      )}
    </>
  );
};

export default SearchAndFilter;